export * from "-!../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./editor.vue?vue&type=template&id=3f07e630&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/Outputs/Images/PhotoEditor/components/editor.vue?vue&type=template&id=3f07e630&scoped=true
// module id = 1391
// module chunks = 31